import {jsonArrayMember, jsonMember, jsonObject} from "typedjson";


/** Действие, навешанное на ту или иную кнопку панели инструментов. */
@jsonObject
export class DxListToolbarAction {
  /** Тип действия выполняемого по кнопке. */
  @jsonMember({name: "type", constructor: String, emitDefaultValue: false, isRequired: false})
  private _type: string;

  /**
   * Обусловлена ли возможность выполнения действия наличием одного и только одного выбранного элемента списка.
   */
  @jsonMember({name: "isSingleItemAction", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _isSingleItemAction: boolean = false;

  /**
   * Обусловлена ли возможность выполнения действия наличием нескольких выбранных элементов списка.
   */
  @jsonMember({name: "isMultiItemAction", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _isMultiItemAction: boolean = false;

  /**
   * Обусловлена ли возможность выполнения действия наличием одного и только одного выбранного элемента списка.
   */
  @jsonMember({name: "isSelectionIndependent", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _isSelectionIndependent: boolean = false;

  // TODO: Придумать для этого флага название по-лучше! Пока у меня фонтазия иссякла :(
  /**
   * Возможность выполнения действия должна определятся при появлении выделения,
   * путем прогона критериев для каждого элемента выделения.
   */
  @jsonMember({name: "isSelectionDependent", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _isSelectionDependent: boolean = false;

  /*@JsonMember({ typeIdent: TaskItemOperation, name: "operation", emitDefaultValue: false, isRequired: false })
  private _operation: TaskItemOperation;*/

  /** Аргументы действия. */
  private _args: Map<string, any>;

  get type(): string {
    return this._type;
  }

  set type(value: string) {
    this._type = value;
  }

  get isSingleItemAction(): boolean {
    return this._isSingleItemAction;
  }

  set isSingleItemAction(value: boolean) {
    this._isSingleItemAction = value;
  }

  get isMultiItemAction(): boolean {
    return this._isMultiItemAction;
  }

  set isMultiItemAction(value: boolean) {
    this._isMultiItemAction = value;
  }

  get isSelectionIndependent(): boolean {
    return this._isSelectionIndependent;
  }

  set isSelectionIndependent(value: boolean) {
    this._isSelectionIndependent = value;
  }

  get isSelectionDependent(): boolean {
    return this._isSelectionDependent;
  }

  set isSelectionDependent(value: boolean) {
    this._isSelectionDependent = value;
  }

  get args(): Map<string, any> {
    return this._args;
  }

  set args(value: Map<string, any>) {
    this._args = value;
  }
}
